import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { motion } from "framer-motion";

import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    Col,
    Container,
    Form,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
} from "reactstrap";
import classnames from "classnames";
import { isEmpty, map } from "lodash";

//Import Star Ratings
import StarRatings from "react-star-ratings";

// RangeSlider
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import { FaDownload, FaMicrophone, FaSearch } from "react-icons/fa";
//Import Product Images
import { productImages } from "assets/images/product";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

//Import data
import { discountData, productsData } from "common/data";

//Import actions
import { getProducts as onGetProducts } from "store/e-commerce/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { FaWhatsapp } from "react-icons/fa";
import { getAll_Category_Properties, getAllProperties, getPropertyByTitle, searchProperties, searchPropertiesoffer, searchProperty } from "service/api";
import { Home, X } from "lucide-react";
import { FiArrowLeft } from "react-icons/fi";
export const MiniPropertySlider = ({ property, height = "120px", borderRadius = "10px" }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!property?.images || property.images.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentImageIndex((prev) =>
                (prev + 1) % property.images.length
            );
        }, 3000);

        return () => clearInterval(interval);
    }, [property?.images]);


    if (!property?.images || property.images.length === 0) {
        return null;
    }

    return (
        <div
            ref={containerRef}
            style={{
                width: "100%",
                height,
                position: "relative",
                overflow: "hidden",
                borderTopLeftRadius: borderRadius,
                borderTopRightRadius: borderRadius,
            }}
        >
            <motion.div
                key={currentImageIndex}
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                }}
            >
                <img
                    src={`https://aiinrealestate.in/api${property.images[currentImageIndex]}`}
                    alt={property.title}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderTopLeftRadius: borderRadius,
                        borderTopRightRadius: borderRadius,
                    }}
                />
            </motion.div>
        </div>
    );
};

const PropertyImageSlider = ({ property, height = "260px", borderRadius = "16px" }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!property?.images || property.images.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentImageIndex(prev => (prev + 1) % property.images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [property?.images]);

    if (!property?.images || property.images.length === 0) {
        return null;
    }

    return (
        <div
            ref={containerRef}
            style={{
                width: "100%",
                height: height,
                position: "relative",
                overflow: "hidden",
                borderRadius: borderRadius,
            }}
        >
            <motion.div
                key={currentImageIndex}
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                }}
            >
                <img
                    src={`https://aiinrealestate.in/api${property.images[currentImageIndex]}`}
                    alt={property.title}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: borderRadius,
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                        border: "2px solid #FFD700",
                    }}
                />
            </motion.div>
        </div>
    );
};

const propertyTypes = [
    { value: "Apartment", label: "Apartment" },
    { value: "Villa", label: "Villa" },
    { value: "Independent House", label: "Independent House" },
    { value: "Studio Apartment", label: "Studio Apartment" },
    { value: "Penthouse", label: "Penthouse" },
    { value: "Townhouse", label: "Townhouse" },
    { value: "Cottage", label: "Cottage" },
    { value: "Bungalow", label: "Bungalow" },
    { value: "Farmhouse", label: "Farmhouse" },
    { value: "Condominium", label: "Condominium" },
    { value: "Loft", label: "Loft" },
    { value: "Serviced Apartment", label: "Serviced Apartment" },
    { value: "Office Space", label: "Office Space" },
    { value: "Retail Space", label: "Retail Space" },
    { value: "Warehouse", label: "Warehouse" },
    { value: "Industrial Property", label: "Industrial Property" },
    { value: "Shop", label: "Shop" },
    { value: "Showroom", label: "Showroom" },
    { value: "Hotel", label: "Hotel" },
    { value: "Restaurant", label: "Restaurant" },
    { value: "Agricultural Land", label: "Agricultural Land" },
    { value: "Plot/Land", label: "Plot/Land" },
    { value: "Beach House", label: "Beach House" },
    { value: "Mountain Cabin", label: "Mountain Cabin" },
    { value: "Vacation Home", label: "Vacation Home" },
    { value: "Luxury Estate", label: "Luxury Estate" },
    { value: "Heritage Property", label: "Heritage Property" },
    { value: "Eco-Friendly Home", label: "Eco-Friendly Home" },
    { value: "Smart Home", label: "Smart Home" },
    { value: "Garage", label: "Garage" },
    { value: "Parking Space", label: "Parking Space" },
    { value: "Storage Unit", label: "Storage Unit" },
    { value: "Mixed-Use Property", label: "Mixed-Use Property" },
];
const availabilitys = [
    { value: "Immediate", label: "Immediate" },
    { value: "Within 15 days", label: "Within 15 days" },
    { value: "Within 30 days", label: "Within 30 days" },
    { value: "After 30 days", label: "Studio After 30 days" },
];


const generateAIInsights = (property) => {
    const insights = [];
    if (property.price) {
        const p = parseFloat(property.price.toString().replace(/[^0-9.]/g, ''));
        if (!isNaN(p)) {
            if (p < 50) insights.push("Budget-friendly price — great for first-time buyers.");
            else if (p < 150) insights.push("Competitive mid-range price with strong location value.");
            else insights.push("Premium pricing — strong resale and rental potential.");
        }
    }
    const status = property.status?.toLowerCase() || '';
    if (status.includes('ready') || status.includes('move')) insights.push("Ready to move in — zero waiting period.");
    else if (status.includes('construct') || status.includes('under')) insights.push("Under construction — early buyer pricing advantage.");
    else if (status.includes('rent')) insights.push("Available for rent — immediate occupancy possible.");
    else if (property.status) insights.push(`${property.status} — contact for availability.`);
    const beds = property.property_details?.[0]?.bedrooms;
    if (beds > 0) {
        if (beds === 1) insights.push("Compact 1 BHK — perfect for singles or investment.");
        else if (beds === 2) insights.push("2 BHK layout — optimal for small families.");
        else if (beds === 3) insights.push("Spacious 3 BHK — high demand in this segment.");
        else insights.push(`${beds} BHK — ideal for large families.`);
    }
    if (property.area_sqft) {
        const area = parseFloat(property.area_sqft);
        if (area > 2000) insights.push(`Large ${area} sqft — excellent value per sqft.`);
        else if (area > 1000) insights.push(`Well-sized ${area} sqft with good space utilization.`);
        else if (area > 0) insights.push(`Compact ${area} sqft — easy to maintain.`);
    }
    if (property.city) insights.push(`Located in ${property.city}${property.location ? ', ' + property.location : ''}.`);
    if (property.festive_offer === 'yes') insights.push("Special festive offer — limited time deal.");
    return insights.slice(0, 4);
};

const calculateEMI = (price) => {
    if (!price) return null;
    const p = parseFloat(price.toString().replace(/[^0-9.]/g, ''));
    if (isNaN(p) || p <= 0) return null;
    const principal = p * 100000 * 0.9;
    const r = 8.5 / (12 * 100);
    const n = 240;
    const emi = principal * r * Math.pow(1 + r, n) / (Math.pow(1 + r, n) - 1);
    return Math.round(emi).toLocaleString('en-IN');
};

const getYTEmbed = (url) => {
    if (!url) return null;
    let videoID = null;
    if (url.includes('youtube.com/watch?v=')) videoID = url.split('v=')[1]?.split('&')[0];
    else if (url.includes('youtu.be/')) videoID = url.split('youtu.be/')[1]?.split('?')[0];
    else if (url.includes('youtube.com/live/')) videoID = url.split('/live/')[1]?.split('?')[0];
    else if (url.includes('youtube.com/embed/')) {
        return url.includes('autoplay=') ? url : `${url}${url.includes('?') ? '&' : '?'}autoplay=1&mute=1`;
    }
    return videoID ? `https://www.youtube.com/embed/${videoID}?autoplay=1&mute=1&rel=0&playsinline=1` : null;
};

const AIExpertModal = ({ isOpen, property, onClose }) => {
    const [imgIdx, setImgIdx] = useState(0);
    const imgScrollRef = useRef(null);
    const images = property?.images || [];
    const videos = (property?.videos || []).filter(v => v && String(v).trim() !== '');

    useEffect(() => {
        if (!isOpen || images.length <= 1) return;
        const t = setInterval(() => {
            setImgIdx(prev => (prev + 1) % images.length);
        }, 3000);
        return () => clearInterval(t);
    }, [isOpen, images.length]);

    useEffect(() => {
        if (imgScrollRef.current) {
            const w = imgScrollRef.current.offsetWidth;
            imgScrollRef.current.scrollTo({ left: w * imgIdx, behavior: 'smooth' });
        }
    }, [imgIdx]);

    useEffect(() => {
        if (isOpen) setImgIdx(0);
    }, [isOpen]);

    if (!isOpen || !property) return null;
    const insights = generateAIInsights(property);
    const emi = calculateEMI(property.price);
    return (
        <div
            style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)',
                zIndex: 99999, display: 'flex', alignItems: 'center',
                justifyContent: 'center', padding: '16px',
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: 'linear-gradient(145deg, #0f0528 0%, #1e0f4a 50%, #2a1060 100%)',
                    borderRadius: '18px', maxWidth: '420px', width: '100%',
                    maxHeight: '88vh', overflowY: 'auto',
                    border: '1px solid rgba(157, 78, 221, 0.5)',
                    boxShadow: '0 24px 80px rgba(0,0,0,0.7), 0 0 0 1px rgba(157,78,221,0.15)',
                    scrollbarWidth: 'thin', scrollbarColor: 'rgba(157,78,221,0.3) transparent',
                }}
                onClick={e => e.stopPropagation()}
            >
                {/* Image Header - Scrolling Carousel */}
                <div style={{ position: 'relative' }}>
                    {images.length > 0 ? (
                        <>
                            <div
                                ref={imgScrollRef}
                                style={{
                                    display: 'flex', overflowX: 'auto',
                                    scrollSnapType: 'x mandatory',
                                    height: '190px', width: '100%',
                                    scrollbarWidth: 'none',
                                    borderTopLeftRadius: '18px', borderTopRightRadius: '18px',
                                }}
                                className="ai-modal-scroll"
                            >
                                {images.map((img, i) => (
                                    <div key={i} style={{
                                        minWidth: '100%', height: '190px', flexShrink: 0,
                                        scrollSnapAlign: 'start',
                                    }}>
                                        <img
                                            src={`https://aiinrealestate.in/api${img}`}
                                            alt={`${property.title || 'Property'} ${i + 1}`}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    </div>
                                ))}
                            </div>
                            {images.length > 1 && (
                                <div style={{
                                    position: 'absolute', bottom: '10px', left: '50%',
                                    transform: 'translateX(-50%)', display: 'flex', gap: '5px',
                                    background: 'rgba(0,0,0,0.4)', padding: '5px 8px', borderRadius: '10px',
                                }}>
                                    {images.map((_, i) => (
                                        <div key={i} onClick={() => setImgIdx(i)} style={{
                                            width: imgIdx === i ? '16px' : '6px', height: '6px', borderRadius: '3px',
                                            background: imgIdx === i ? '#fff' : 'rgba(255,255,255,0.5)',
                                            transition: 'width 0.3s', cursor: 'pointer',
                                        }} />
                                    ))}
                                </div>
                            )}
                        </>
                    ) : (
                        <div style={{
                            height: '100px',
                            background: 'linear-gradient(135deg, #2d1b69, #4a0e8f)',
                            borderTopLeftRadius: '18px', borderTopRightRadius: '18px',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <span style={{ fontSize: '2.5rem' }}>🏠</span>
                        </div>
                    )}
                    {/* WhatsApp share icon */}
                    <button
                        onClick={() => {
                            const slug = property?.title?.trim().replace(/\s+/g, '-') || 'property';
                            const shareURL = `${window.location.origin}/residential/${slug}?ai=true`;
                            const msg = encodeURIComponent(`✨ AI Property Expert Analysis\n\n🏡 ${property.title || 'Property'}\n💰 ${property.price ? '₹' + property.price : 'Price on Request'}\n📍 ${[property.location, property.city].filter(Boolean).join(', ')}\n\n${shareURL}`);
                            window.open(`https://wa.me/?text=${msg}`, '_blank');
                        }}
                        style={{
                            position: 'absolute', top: '10px', left: '10px',
                            background: 'rgba(37,211,102,0.85)', border: 'none', borderRadius: '50%',
                            width: '30px', height: '30px', color: '#fff', cursor: 'pointer',
                            fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                        title="Share on WhatsApp"
                    ><FaWhatsapp /></button>
                    <button
                        onClick={onClose}
                        style={{
                            position: 'absolute', top: '10px', right: '10px',
                            background: 'rgba(0,0,0,0.65)', border: 'none', borderRadius: '50%',
                            width: '30px', height: '30px', color: '#fff', cursor: 'pointer',
                            fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                    >✕</button>
                </div>

                {/* Video section */}
                {videos.length > 0 && (
                    <div style={{ padding: '10px 12px 0 12px' }}>
                        <div style={{
                            display: 'flex', overflowX: 'auto', gap: '8px',
                            scrollSnapType: 'x mandatory', scrollbarWidth: 'thin',
                            scrollbarColor: 'rgba(157,78,221,0.4) transparent',
                            paddingBottom: '4px',
                        }}
                            className="ai-modal-scroll-x"
                        >
                            {videos.map((v, i) => {
                                const embed = getYTEmbed(v);
                                if (!embed) return null;
                                return (
                                    <iframe
                                        key={i}
                                        src={embed}
                                        title={`video-${i}`}
                                        style={{
                                            minWidth: '100%', height: '180px', border: 'none',
                                            borderRadius: '10px', flexShrink: 0,
                                            scrollSnapAlign: 'start',
                                        }}
                                        allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />
                                );
                            })}
                        </div>
                    </div>
                )}

                <div style={{ padding: '16px' }}>
                    {/* Title + Price */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                        <div style={{ flex: 1, marginRight: '12px' }}>
                            <h6 style={{ color: '#e2d9f3', margin: 0, fontWeight: 700, fontSize: '0.95rem', lineHeight: 1.3 }}>
                                {property.title || 'Property'}
                            </h6>
                            <div
                                style={{ color: '#c77dff', fontSize: '0.72rem', marginTop: '3px', cursor: 'pointer' }}
                                onClick={() => {
                                    onClose();
                                    const slug = property?.title?.trim().replace(/\s+/g, '-') || 'property';
                                    window.location.href = `/residential/${slug}`;
                                }}
                            >
                                View Full Details &rarr;
                            </div>
                        </div>
                        <div style={{ textAlign: 'right', flexShrink: 0 }}>
                            <div style={{ color: '#fff', fontWeight: 800, fontSize: '1.1rem' }}>
                                {property.price ? `₹${property.price}` : 'Price on Request'}
                            </div>
                            <div style={{ color: '#8880a0', fontSize: '0.68rem', marginTop: '2px' }}>
                                {[property.location, property.city].filter(Boolean).join(', ')}
                            </div>
                        </div>
                    </div>

                    {/* AI Property Expert Analysis */}
                    <div style={{
                        background: 'linear-gradient(135deg, rgba(74,222,128,0.07), rgba(34,211,238,0.04))',
                        border: '1px solid rgba(74,222,128,0.3)',
                        borderRadius: '12px', padding: '14px', marginBottom: '12px',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                <div style={{
                                    width: '26px', height: '26px', borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #4ade80, #22d3ee)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px',
                                }}>✨</div>
                                <span style={{ color: '#4ade80', fontWeight: 700, fontSize: '0.88rem' }}>AI Property Expert Analysis</span>
                            </div>
                            <span style={{
                                background: 'linear-gradient(135deg, #00C853, #00e676)',
                                color: '#fff', fontSize: '0.6rem', fontWeight: 800,
                                padding: '3px 8px', borderRadius: '4px', letterSpacing: '0.5px',
                            }}>SMART PICK</span>
                        </div>
                        {insights.length > 0 ? insights.map((insight, i) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '7px', marginBottom: '7px' }}>
                                <span style={{ color: '#4ade80', fontSize: '0.72rem', flexShrink: 0, marginTop: '1px' }}>✓</span>
                                <span style={{ color: '#d4fce8', fontSize: '0.78rem', lineHeight: 1.45 }}>{insight}</span>
                            </div>
                        )) : (
                            <div style={{ color: '#a0c4a0', fontSize: '0.78rem' }}>AI analysis based on property data.</div>
                        )}
                    </div>

                    {/* EMI */}
                    {emi && (
                        <div style={{
                            background: 'rgba(199,125,255,0.07)',
                            border: '1px solid rgba(199,125,255,0.25)',
                            borderRadius: '12px', padding: '13px', marginBottom: '12px',
                        }}>
                            <div style={{ color: '#8880a0', fontSize: '0.65rem', marginBottom: '5px', letterSpacing: '0.6px', textTransform: 'uppercase' }}>
                                EMI Starts At
                            </div>
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'wrap' }}>
                                <span style={{ color: '#c77dff', fontSize: '1.25rem', fontWeight: 700 }}>₹{emi}</span>
                                <span style={{ color: '#8880a0', fontSize: '0.72rem' }}>/month</span>
                                <span style={{ color: '#6b6b80', fontSize: '0.62rem', marginLeft: 'auto' }}>8.5% for 20 yrs*</span>
                            </div>
                            <div style={{ color: '#6b6b80', fontSize: '0.62rem', marginTop: '3px' }}>*Indicative — 90% loan on principal</div>
                        </div>
                    )}

                    {/* Quick Stats Grid */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '14px' }}>
                        {[
                            { icon: '🏠', label: 'Type', value: property.property_type || 'N/A' },
                            { icon: '📐', label: 'Area', value: property.area_sqft ? `${property.area_sqft} sqft` : 'N/A' },
                            { icon: '🛏️', label: 'Bedrooms', value: property.property_details?.[0]?.bedrooms > 0 ? `${property.property_details[0].bedrooms} BHK` : 'N/A' },
                            { icon: '📋', label: 'Status', value: property.status || 'N/A' },
                        ].map((stat, i) => (
                            <div key={i} style={{
                                background: 'rgba(255,255,255,0.04)', borderRadius: '9px',
                                padding: '10px 12px', border: '1px solid rgba(255,255,255,0.07)',
                            }}>
                                <div style={{ fontSize: '0.62rem', color: '#7a7090', marginBottom: '4px' }}>{stat.icon} {stat.label}</div>
                                <div style={{ fontSize: '0.78rem', color: '#e2d9f3', fontWeight: 600 }}>{stat.value}</div>
                            </div>
                        ))}
                    </div>

                    {/* CTA */}
                    <button
                        onClick={() => {
                            onClose();
                            const slug = property?.title?.trim().replace(/\s+/g, '-') || 'property';
                            window.location.href = `/residential/${slug}`;
                        }}
                        style={{
                            width: '100%', padding: '13px',
                            background: 'linear-gradient(135deg, #7B2FBE, #9D4EDD, #c77dff)',
                            border: 'none', borderRadius: '11px', color: '#fff',
                            fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer',
                            boxShadow: '0 4px 20px rgba(123,47,190,0.5)',
                        }}
                    >
                        View Full Property Details
                    </button>

                </div>
            </div>
        </div>
    );
};

const OfferProperty = () => {

    //meta title
    document.title = "Properties | Aiinrealestate";

    const navigate = useNavigate();

    const [selectedPropertyType, setSelectedPropertyType] = useState("");
    const [propertyTypeSearch, setPropertyTypeSearch] = useState("");
    const [filters, setFilters] = useState({
        discount: [],
        price: { min: 0, max: 500 },
    });

    const phoneNumber = "+919586363303";

    // Function to generate the WhatsApp URL with the current page URL
    const generateWhatsAppLink = () => {
        const currentPageURL = window.location.href; // Get the current page URL
        const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
        return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    };

    const cardStyle = {
        background: "rgba(255, 255, 255, 0.1)",
        border: "none",
        borderRadius: "15px",
    };

    const [properties, setProperties] = useState([]);
    const [Category_Properties, set_Category_Properties] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [All_Category_Properties, set_All_Category_Properties] = useState([]);

    const [isListening, setIsListening] = useState(false);
    const [selectedArea, setSelectedArea] = useState("");
    const [minPrice, setMinPrice] = useState("");
    const [maxPrice, setMaxPrice] = useState("");

    // const [isMobile, setIsMobile] = useState(false);

    const fetchProperty = async () => {
        try {
            const data = await getAllProperties();
            console.log("Fetched Data:", data); // Debugging

            // Ensure properties is always an array
            if (data?.success && Array.isArray(data.properties)) {
                setProperties(data.properties);
            } else {
                console.error("Invalid response format:", data);
                setProperties([]); // Prevent crash
            }
        } catch (error) {
            console.error("API Error:", error);
            setProperties([]);
        }
    };

    const fetch_Category_Properties = async () => {
        try {
            const data = await getAll_Category_Properties();
            if (data?.success && Array.isArray(data.data)) {
                const festiveCategories = data.data
                    .map((category) => {
                        const festiveProperties = category.properties.filter(
                            (property) => property.festive_offer?.toLowerCase() === "yes"
                        );
                        if (festiveProperties.length > 0) {
                            return {
                                ...category,
                                properties: festiveProperties,
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);

                set_All_Category_Properties(festiveCategories);  // Store unfiltered
                set_Category_Properties(festiveCategories);       // For display
            } else {
                set_All_Category_Properties([]);
                set_Category_Properties([]);
            }
        } catch (error) {
            set_All_Category_Properties([]);
            set_Category_Properties([]);
        }
    };

    // Fetch all properties on component mount
    useEffect(() => {
        // fetchProperty();
        fetch_Category_Properties();
    }, []);

    const scrollContainer = (categoryId, direction) => {
        const el = containerRefs.current[categoryId];
        if (el) el.scrollBy({ left: direction * 340, behavior: 'smooth' });
    };

    // const handleSearch = (query) => {
    //     const trimmedQuery = query.trim().toLowerCase();
    //     setSearchQuery(trimmedQuery);

    //     if (!trimmedQuery) {
    //         set_Category_Properties(All_Category_Properties); // Reset to all festive properties
    //         return;
    //     }

    //     const filteredCategories = All_Category_Properties.map((category) => {
    //         const matchedProperties = category.properties.filter((property) => {
    //             // Search in multiple fields for better results
    //             return (
    //                 (property.title?.toLowerCase().includes(trimmedQuery)) ||
    //                 (property.location?.toLowerCase().includes(trimmedQuery)) ||
    //                 (property.description?.toLowerCase().includes(trimmedQuery)) ||
    //                 (property.price?.toString().includes(trimmedQuery)) ||
    //                 (property.area_sqft?.toString().includes(trimmedQuery))
    //             );
    //         });

    //         if (matchedProperties.length > 0) {
    //             return {
    //                 ...category,
    //                 properties: matchedProperties,
    //             };
    //         }
    //         return null;
    //     }).filter(Boolean);

    //     set_Category_Properties(filteredCategories);
    // };

    const handleSearch = (query) => {
        const trimmedQuery = query.trim().toLowerCase();
        setSearchQuery(trimmedQuery);

        if (!trimmedQuery) {
            set_Category_Properties(All_Category_Properties); // Reset to all festive properties
            return;
        }

        const filteredCategories = All_Category_Properties.map((category) => {
            const matchedProperties = category.properties.filter((property) => {
                // Search in multiple fields for better results
                return (
                    (property.title?.toLowerCase().includes(trimmedQuery)) ||
                    (property.location?.toLowerCase().includes(trimmedQuery)) ||
                    (property.description?.toLowerCase().includes(trimmedQuery)) ||
                    (property.price?.toString().includes(trimmedQuery)) ||
                    (property.area_sqft?.toString().includes(trimmedQuery))
                );
            });

            if (matchedProperties.length > 0) {
                return {
                    ...category,
                    properties: matchedProperties,
                };
            }
            return null;
        }).filter(Boolean);

        set_Category_Properties(filteredCategories);
    };
    // Filter property types based on search
    const filteredPropertyTypes = propertyTypes.filter(type =>
        type.label.toLowerCase().includes(propertyTypeSearch.toLowerCase())
    );

    const handleFilterSearch = async () => {
        // First filter by festive properties from the existing data
        let filteredFestive = All_Category_Properties.map(category => {
            const filteredProps = category.properties.filter(property => {
                // Filter by selected areas if any
                const areaMatch = selectedAreas.length === 0 ||
                    selectedAreas.some(area =>
                        property.location?.toLowerCase().includes(area.toLowerCase())
                    );

                // Filter by price range if set
                const priceMatch = (!minPrice || !maxPrice) ||
                    (property.price &&
                        property.price >= parseInt(minPrice) &&
                        property.price <= parseInt(maxPrice));

                // Filter by property type if selected
                const propertyTypeMatch = !selectedPropertyType ||
                    property.property_type?.toLowerCase() === selectedPropertyType.toLowerCase();

                return areaMatch && priceMatch && propertyTypeMatch;
            });

            return filteredProps.length > 0 ? {
                ...category,
                properties: filteredProps
            } : null;
        }).filter(Boolean);

        set_Category_Properties(filteredFestive);
    };
    // Clear property type filter
    const clearPropertyType = () => {
        setSelectedPropertyType("");
        setPropertyTypeSearch("");
    };

    const toggleListening = () => {
        if (!isListening) {
            startListening();
        } else {
            stopListening();
        }
    };
    // 🟢 Voice Search Function
    const startListening = () => {
        if (!("webkitSpeechRecognition" in window)) {
            alert("Your browser does not support voice search.");
            return;
        }

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = "en-US";
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onstart = () => setIsListening(true);
        recognition.onend = () => setIsListening(false);

        recognition.onresult = (event) => {
            const spokenText = event.results[0][0].transcript;
            setSearchQuery(spokenText);
            handleSearch({ target: { value: spokenText } });
        };
        recognition.start();
        console.log("Mic is ON");
    };

    const stopListening = () => {
        setIsListening(false);
        // Stop the speech recognition logic
        console.log("Mic is OFF");
    };
    const clearSearch = () => {
        setSearchQuery("");
    };
    const [availability, setavailability] = useState("");
    const [transactionType, setTransactionType] = useState(null);
    const vadodaraAreas = [
        "Alkapuri", "Fatehgunj", "Gorwa", "Gotri", "Manjalpur", "Waghodia", "Bhayli", "Harni", "Tarsali", "Makarpura", "Ellora Park", "Karelibaug", "Subhanpura", "Chhani", "New VIP Road", "Sayajiganj", "Ajwa Road", "Akota", "Atladara", "Bajwa", "Baranpura", "Diwalipura", "GIDC Makarpura", "Kothi", "Nizampura", "Panchvati", "Pratapgunj", "Rajmahal Road", "Sama", "Sama-Savli Road", "Sun Pharma Road", "Vadsar", "Vasna Road", "Wadi", "Kalali", "Sevasi", "Sindhrot", "Tandalja", "Vishwamitri"
    ];

    const toggleAreaSelection = (area) => {
        setSelectedArea((prev) =>
            prev.includes(area) ? prev.filter((a) => a !== area) : [...prev, area]
        );
    };
    const priceOptions = ["₹5 Lac", "₹10 Lac", "₹20 Lac", "₹30 Lac", "₹40 Lac", "₹50 Lac", "₹60 Lac", "₹70 Lac", "₹80 Lac", "₹90 Lac", "₹1 Cr", "₹1.2 Cr", "₹1.4 Cr", "₹1.6 Cr", "1.8 Cr", "₹2 Cr", "₹2.3 Cr", "₹2.6 Cr", "₹3 Cr", "₹3.5 Cr", "₹3.5 Cr", "₹4 Cr", "₹4.5 Cr", "₹5 Cr", "₹10 Cr", "₹20 Cr"];

    const handleCategoryClick = (category) => {
        setSearchQuery(category);
        handleSearch(category);
    };

    const whatsappNumber = "919586363303";
    const whatsappMessage = encodeURIComponent(
        `Hello, I would like to post a property. I am sharing the required details:\n\n📍 Property Location: \n🏠 Property type
 \n Built-up Year: \n📏 Area (in sq. feet): \n🖼️ Images of property \n Video of property

: \n📄 Additional Information: \n`
    );

    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isDropdownpopentype, setIsDropdownOpenptype] = useState(false);
    const [propertyType, setPropertyType] = useState("");
    const [subPropertyType, setSubPropertyType] = useState(null);
    const [selectedCommercialTypes, setSelectedCommercialTypes] = useState([]);
    const [selectedBHK, setSelectedBHK] = useState(null);

    const propertyOptions = ["Residential", "Commercial", "Other Property Types"];

    const residentialOptions = ["Flat", "House/Villa"];
    const bhkOptions = ["1 BHK", "2 BHK", "3 BHK", "4 BHK", "5+ BHK"];

    const commercialOptions = [
        "Office Space",
        "Shop/Showroom",
        "Commercial Land",
        "Warehouse/Godown",
        "Industrial Building",
        "Industrial Shed",
    ];

    const otherOptions = ["Agricultural", "Farm House"];


    const handleSelectProperty = (type) => {
        setPropertyType(type);
        setSubPropertyType(null);
        setSelectedCommercialTypes([]);
        setSelectedBHK(null);
    };

    const handleSubPropertySelect = (subType) => {
        setSubPropertyType(subType);
        setSelectedBHK(null);
        setIsDropdownOpen(false);
    };

    const handleBHKSelect = (bhk) => {
        setSelectedBHK(bhk);
        setIsDropdownOpen(false);
    };

    const handleCommercialSelect = (type) => {
        // setSelectedCommercialTypes((prev) =>
        //   prev.includes(type) ? prev.filter((item) => item !== type) : [...prev, type]
        // );
        setSelectedCommercialTypes([type]); // Only one selected at a time
        setIsDropdownOpen(false);
    };

    const getSelectedPropertyText = () => {
        if (!propertyType) return "";

        if (propertyType === "Residential") {
            if (subPropertyType) {
                return selectedBHK ? `${subPropertyType} - ${selectedBHK}` : subPropertyType;
            }
            return "Residential";
        }

        if (propertyType === "Commercial") {
            return selectedCommercialTypes.length > 0 ? selectedCommercialTypes.join(", ") : "Commercial";
        }

        if (propertyType === "Other Property Types") {
            return subPropertyType || "Other Property Types";
        }

        return propertyType;
    };

    const [isDropdownOpenarea, setIsDropdownOpenarea] = useState(false);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const dropdownRef = useRef(null);
    const [visibleCount, setVisibleCount] = useState(10);
    const [searchQuery2, setSearchQuery2] = useState("");

    const handleSelectArea = (area) => {
        if (selectedAreas.includes(area)) {
            setSelectedAreas(selectedAreas.filter((item) => item !== area));
        } else if (selectedAreas.length < 3) {
            setSelectedAreas([...selectedAreas, area]);
        }
        setIsDropdownOpenarea(false);

    };
    // Filter areas based on search query
    const filteredAreas = vadodaraAreas.filter((area) =>
        area.toLowerCase().includes(searchQuery2.toLowerCase())
    );

    const loadMoreAreas = () => {
        setVisibleCount((prevCount) => prevCount + 10);
    };
    const toggleDropdown = () => {
        setIsDropdownOpenarea((prev) => !prev);
    };
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        handleResize(); // set initially
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const containerRefs = useRef({});
    const [overflowingCategories, setOverflowingCategories] = useState({});

    useEffect(() => {
        const checkOverflow = () => {
            const updatedOverflow = {};
            Object.entries(containerRefs.current).forEach(([categoryId, ref]) => {
                if (ref && ref.scrollWidth > ref.clientWidth) {
                    updatedOverflow[categoryId] = true;
                }
            });
            setOverflowingCategories(updatedOverflow);
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, []);
    const [showTooltip, setShowTooltip] = useState(true);
    useEffect(() => {
        setShowTooltip(true);
    }, []);
    const festiveScrollRef = useRef(null);
    const [showFestiveMore, setShowFestiveMore] = useState(false);
    const [aiModalOpen, setAiModalOpen] = useState(false);
    const [aiSelectedProperty, setAiSelectedProperty] = useState(null);

    useEffect(() => {
        const checkOverflow = () => {
            if (festiveScrollRef.current) {
                const isOverflown = festiveScrollRef.current.scrollWidth > festiveScrollRef.current.clientWidth;
                setShowFestiveMore(isOverflown);
            }
        };
        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => setShowTooltip(false), 120000);
        return () => clearTimeout(timer);
    }, []);

    const handleDeselectArea = (area) => {
        setSelectedAreas((prevAreas) => prevAreas.filter((item) => item !== area));
    };

    useEffect(() => {
        const checkScreenSize = () => setIsMobile(window.innerWidth < 768);
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    const handleSearchoffer = async (input) => {
        const query = input?.target?.value ?? input;
        setSearchQuery(query);

        if (!query) {
            fetchProperty(); // If query is empty, reset to all properties
            return;
        }
        try {
            const data = await searchPropertiesoffer(query);
            console.log("Search Response:", data); // Debugging

            // Ensure properties is always an array
            if (data?.success && Array.isArray(data.properties)) {
                setProperties(data.properties);
            } else {
                console.error("Invalid search response format:", data);
                setProperties([]);
            }
        } catch (error) {
            console.error("Search API Error:", error);
            setProperties([]);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>

                            <br />
                            <Row className="mb-4">
                                <Col lg={12}>
                                    <Form
                                        className="d-flex flex-wrap align-items-center bg-white shadow p-3 rounded-4 w-100 gap-3"
                                        style={{
                                            maxWidth: "1400px",
                                            border: "1px solid #ddd",
                                            margin: "auto",
                                            background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                                        }}
                                    >
                                        {/* Search Input */}
                                        <div className="d-flex align-items-center flex-grow-1 position-relative" style={{ minWidth: "300px" }}>
                                            <input
                                                type="text"
                                                className="form-control shadow-sm"
                                                placeholder="Search festive offers..."
                                                value={searchQuery}
                                                onChange={(e) => handleSearchoffer(e.target.value)}
                                                style={{
                                                    height: "40px",
                                                    borderRadius: "50px",
                                                    padding: "0 40px 0 20px",
                                                    fontSize: "15px",
                                                    backgroundColor: "#f5f5f5",
                                                    border: "1px solid #ccc",
                                                    outline: "none",
                                                }}
                                            />
                                            {searchQuery && (
                                                <span
                                                    onClick={clearSearch}
                                                    style={{
                                                        position: "absolute",
                                                        right: "50px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        color: "#888",
                                                    }}
                                                >
                                                    ✕
                                                </span>
                                            )}
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    right: "15px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    color: "#aaa",
                                                }}
                                            >
                                                <FaMicrophone
                                                    onClick={toggleListening}
                                                    style={{
                                                        cursor: "pointer",
                                                        color: isListening ? "#ff0000" : "#5A189A",
                                                        animation: isListening ? "pulse 1.5s infinite" : "none"
                                                    }}
                                                />
                                            </span>
                                        </div>

                                        {/* Property Type Filter */}
                                        <div className="position-relative">
                                            <Button
                                                className="rounded-4 d-flex align-items-center gap-2"
                                                style={{
                                                    height: "38px",
                                                    fontWeight: "bold",
                                                    background: "#5A189A",
                                                    color: "white",
                                                    border: "none",
                                                    padding: "0 15px",
                                                    minWidth: "180px"
                                                }}
                                                onClick={() => setIsDropdownOpenptype(!isDropdownpopentype)}
                                            >
                                                {selectedPropertyType || "Property Type"}
                                                <i className={`fas fa-chevron-${isDropdownpopentype ? "up" : "down"} ms-1`}></i>
                                            </Button>

                                            {isDropdownpopentype && (
                                                <div style={{
                                                    position: "absolute",
                                                    top: "100%",
                                                    left: 0,
                                                    zIndex: 1000,
                                                    background: "white",
                                                    borderRadius: "10px",
                                                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                                    width: "250px",
                                                    padding: "10px",
                                                    marginTop: "5px"
                                                }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Search property types..."
                                                        value={propertyTypeSearch}
                                                        onChange={(e) => setPropertyTypeSearch(e.target.value)}
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            marginBottom: "8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ddd"
                                                        }}
                                                    />

                                                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                        {filteredPropertyTypes.map((type) => (
                                                            <div
                                                                key={type.value}
                                                                style={{
                                                                    padding: "8px",
                                                                    cursor: "pointer",
                                                                    backgroundColor: selectedPropertyType === type.value ? "#f0e6ff" : "transparent",
                                                                    borderRadius: "5px",
                                                                    marginBottom: "2px",
                                                                }}
                                                                onClick={() => {
                                                                    setSelectedPropertyType(type.value);
                                                                    setIsDropdownOpenptype(false);
                                                                    setPropertyTypeSearch("");
                                                                }}
                                                            >
                                                                {type.label}
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {selectedPropertyType && (
                                                        <button
                                                            onClick={() => {
                                                                clearPropertyType();
                                                                setIsDropdownOpenptype(false);
                                                            }}
                                                            style={{
                                                                width: "100%",
                                                                padding: "5px",
                                                                background: "transparent",
                                                                border: "none",
                                                                color: "#5A189A",
                                                                cursor: "pointer",
                                                                textAlign: "center",
                                                                marginTop: "5px"
                                                            }}
                                                        >
                                                            Clear Selection
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>


                                        {/* Area Filter */}
                                        <div className="position-relative">
                                            <Button
                                                className="rounded-4 d-flex align-items-center gap-2"
                                                style={{
                                                    height: "38px",
                                                    fontWeight: "bold",
                                                    background: "#5A189A",
                                                    color: "white",
                                                    border: "none",
                                                    padding: "0 15px",
                                                    minWidth: "120px"
                                                }}
                                                onClick={() => setIsDropdownOpenarea(!isDropdownOpenarea)}
                                            >
                                                {selectedAreas.length > 0 ? `${selectedAreas.length} Area` : "All Areas"}
                                                <i className={`fas fa-chevron-${isDropdownOpenarea ? "up" : "down"} ms-1`}></i>
                                            </Button>

                                            {isDropdownOpenarea && (
                                                <div style={{
                                                    position: "absolute",
                                                    top: "100%",
                                                    left: 0,
                                                    zIndex: 1000,
                                                    background: "white",
                                                    borderRadius: "10px",
                                                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                                    width: "250px",
                                                    maxHeight: "300px",
                                                    overflowY: "auto",
                                                    padding: "10px",
                                                    marginTop: "5px"
                                                }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Search areas..."
                                                        value={searchQuery2}
                                                        onChange={(e) => setSearchQuery2(e.target.value)}
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            marginBottom: "8px",
                                                            borderRadius: "5px",
                                                            border: "1px solid #ddd"
                                                        }}
                                                    />

                                                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                        {filteredAreas.slice(0, visibleCount).map((area) => (
                                                            <div
                                                                key={area}
                                                                style={{
                                                                    padding: "8px",
                                                                    cursor: "pointer",
                                                                    backgroundColor: selectedAreas.includes(area) ? "#f0e6ff" : "transparent",
                                                                    borderRadius: "5px",
                                                                    marginBottom: "2px",
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                }}
                                                                onClick={() => handleSelectArea(area)}
                                                            >
                                                                <span style={{ flex: 1 }}>{area}</span>
                                                                {selectedAreas.includes(area) && (
                                                                    <i className="fas fa-check text-primary"></i>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {visibleCount < filteredAreas.length && (
                                                        <button
                                                            onClick={loadMoreAreas}
                                                            style={{
                                                                width: "100%",
                                                                padding: "5px",
                                                                background: "transparent",
                                                                border: "none",
                                                                color: "#5A189A",
                                                                cursor: "pointer",
                                                                textAlign: "center"
                                                            }}
                                                        >
                                                            Load More
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        {/* Price Range Filter */}
                                        <div className="position-relative">
                                            <Button
                                                className="rounded-4 d-flex align-items-center gap-2"
                                                style={{
                                                    height: "38px",
                                                    fontWeight: "bold",
                                                    background: "#5A189A",
                                                    color: "white",
                                                    border: "none",
                                                    padding: "0 15px",
                                                    minWidth: "180px"
                                                }}
                                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                            >
                                                {minPrice && maxPrice ?
                                                    `₹${(minPrice / 100000).toFixed(1)}L - ₹${(maxPrice / 100000).toFixed(1)}L` :
                                                    "Any Price"}
                                                <i className={`fas fa-chevron-${isDropdownOpen ? "up" : "down"} ms-1`}></i>
                                            </Button>

                                            {isDropdownOpen && (
                                                <div style={{
                                                    position: "absolute",
                                                    top: "100%",
                                                    left: 0,
                                                    zIndex: 1000,
                                                    background: "white",
                                                    borderRadius: "10px",
                                                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                                    width: "250px",
                                                    padding: "15px",
                                                    marginTop: "5px"
                                                }}>
                                                    <div className="mb-3">
                                                        <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>
                                                            Min Price
                                                        </label>
                                                        <select
                                                            className="form-select"
                                                            value={minPrice}
                                                            onChange={(e) => setMinPrice(e.target.value)}
                                                            style={{ fontSize: "14px" }}
                                                        >
                                                            <option value="">Any Min</option>
                                                            {priceOptions.map((price, index) => (
                                                                <option key={`min-${index}`} value={price.replace('₹', '').replace(' Lac', '00000').replace(' Cr', '0000000')}>
                                                                    {price}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="mb-3">
                                                        <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>
                                                            Max Price
                                                        </label>
                                                        <select
                                                            className="form-select"
                                                            value={maxPrice}
                                                            onChange={(e) => setMaxPrice(e.target.value)}
                                                            style={{ fontSize: "14px" }}
                                                        >
                                                            <option value="">Any Max</option>
                                                            {priceOptions.map((price, index) => (
                                                                <option
                                                                    key={`max-${index}`}
                                                                    value={price.replace('₹', '').replace(' Lac', '00000').replace(' Cr', '0000000')}
                                                                    disabled={minPrice && parseInt(price.replace('₹', '').replace(' Lac', '00000').replace(' Cr', '0000000')) < parseInt(minPrice)}
                                                                >
                                                                    {price}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <button
                                                        onClick={() => {
                                                            setIsDropdownOpen(false);
                                                            handleFilterSearch();
                                                        }}
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            background: "#5A189A",
                                                            color: "white",
                                                            border: "none",
                                                            borderRadius: "5px",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        Apply Price
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {/* Search Button */}
                                        <Button
                                            onClick={handleFilterSearch}
                                            className="rounded-4 d-flex align-items-center gap-2"
                                            style={{
                                                height: "38px",
                                                fontWeight: "bold",
                                                background: "#5A189A",
                                                padding: "0 20px"
                                            }}
                                        >
                                            <FaSearch size={20} />
                                            Find Offers
                                        </Button>
                                    </Form>

                                    {/* Selected Filters */}
                                    {(selectedAreas.length > 0 || minPrice || maxPrice) && (
                                        <div className="d-flex flex-wrap gap-2 mt-2 align-items-center">
                                            <small className="text-muted">Filters:</small>

                                            {selectedAreas.map(area => (
                                                <div
                                                    key={area}
                                                    style={{
                                                        background: "#f0e6ff",
                                                        color: "#5A189A",
                                                        padding: "5px 10px",
                                                        borderRadius: "20px",
                                                        fontSize: "14px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "5px"
                                                    }}
                                                >
                                                    {area}
                                                    <X
                                                        size={14}
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            handleDeselectArea(area);
                                                            handleFilterSearch();
                                                        }}
                                                    />
                                                </div>
                                            ))}

                                            {(minPrice || maxPrice) && (
                                                <div
                                                    style={{
                                                        background: "#f0e6ff",
                                                        color: "#5A189A",
                                                        padding: "5px 10px",
                                                        borderRadius: "20px",
                                                        fontSize: "14px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "5px"
                                                    }}
                                                >
                                                    {minPrice ? `₹${(minPrice / 100000).toFixed(1)}L` : "Any"} - {maxPrice ? `₹${(maxPrice / 100000).toFixed(1)}L` : "Any"}
                                                    <X
                                                        size={14}
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            setMinPrice("");
                                                            setMaxPrice("");
                                                            handleFilterSearch();
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            {selectedPropertyType && (
                                                <div
                                                    style={{
                                                        background: "#f0e6ff",
                                                        color: "#5A189A",
                                                        padding: "5px 10px",
                                                        borderRadius: "20px",
                                                        fontSize: "14px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "5px"
                                                    }}
                                                >
                                                    {selectedPropertyType}
                                                    <X
                                                        size={14}
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            clearPropertyType();
                                                            handleFilterSearch();
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            <button
                                                onClick={() => {
                                                    setSelectedAreas([]);
                                                    setMinPrice("");
                                                    setMaxPrice("");
                                                    clearPropertyType();
                                                    handleFilterSearch();
                                                }}
                                                style={{
                                                    background: "transparent",
                                                    border: "none",
                                                    color: "#5A189A",
                                                    fontSize: "14px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px"
                                                }}
                                            >
                                                <X size={14} />
                                                Clear all
                                            </button>
                                        </div>
                                    )}

                                    {/* Pulse animation for mic */}
                                    <style>
                                        {`
                @keyframes pulse {
                    0% { box-shadow: 0 0 0 0 rgba(255, 65, 108, 0.7); }
                    70% { box-shadow: 0 0 0 10px rgba(255, 65, 108, 0); }
                    100% { box-shadow: 0 0 0 0 rgba(255, 65, 108, 0); }
                }
            `}
                                    </style>
                                </Col>
                            </Row>

                            {!searchQuery && Category_Properties
                                .filter(category => category.properties.length > 0)
                                .map(category => (
                                    <div key={category.category_id} className="mb-4">
                                        {/* Category Heading */}
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h4
                                                className="mb-0"
                                                style={{
                                                    color: '#ffffff',
                                                    fontWeight: '600',
                                                    borderBottom: '1px solid #9D4EDD',
                                                    paddingBottom: '4px',
                                                    display: 'inline-block',
                                                    fontSize: '1.1rem'
                                                }}
                                            >
                                                {category.category_name}
                                            </h4>
                                        </div>

                                        {/* Properties Container with Arrow Buttons */}
                                        <div style={{ position: 'relative' }}>
                                            {/* Left Arrow — only when enough cards to scroll */}
                                            {category.properties.length > (isMobile ? 2 : 4) && (
                                            <button
                                                onClick={() => scrollContainer(category.category_id, -1)}
                                                style={{
                                                    position: 'absolute', left: '-14px', top: '45%',
                                                    transform: 'translateY(-50%)', zIndex: 20,
                                                    background: 'linear-gradient(135deg, #7B2FBE, #9D4EDD)',
                                                    border: 'none', borderRadius: '50%',
                                                    width: '34px', height: '34px',
                                                    color: '#fff', cursor: 'pointer',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    fontSize: '18px', fontWeight: 'bold',
                                                    boxShadow: '0 4px 14px rgba(123,47,190,0.6)',
                                                    lineHeight: 1,
                                                }}
                                            >‹</button>
                                            )}

                                            <div
                                            className="properties-container"
                                            ref={el => containerRefs.current[category.category_id] = el}
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'nowrap',
                                                overflowX: 'auto',
                                                gap: '16px',
                                                paddingBottom: '8px',
                                                scrollSnapType: 'x mandatory',
                                                scrollbarWidth: 'thin',
                                                scrollbarColor: '#7B2FBE transparent',
                                            }}
                                        >
                                            {category.properties.map((property, index) => {
                                                if (property.isViewMoreCard) {
                                                    const hasFestive = category.properties.some(p => p.festive_offer === 'yes');
                                                    if (!hasFestive) return null;

                                                    return (
                                                        <div
                                                            key="view-more-card"
                                                            style={{
                                                                scrollSnapAlign: 'start',
                                                                minWidth: isMobile ? 'calc(50% - 8px)' : '220px',
                                                                flexShrink: 0,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                border: '1px dashed rgba(255,255,255,0.3)',
                                                                borderRadius: '10px',
                                                            }}
                                                        >
                                                            <a
                                                                href="https://aiinrealestate.in/developers"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '10px 20px',
                                                                    background: '#1F1147',
                                                                    color: '#fff',
                                                                    borderRadius: '40px',
                                                                    fontSize: '0.95rem',
                                                                    fontWeight: 600,
                                                                    textDecoration: 'none',
                                                                    boxShadow: '0 0 12px rgba(157, 78, 221, 0.6)',
                                                                    transition: 'all 0.35s ease',
                                                                }}
                                                                onMouseEnter={e => {
                                                                    e.currentTarget.style.boxShadow = '0 0 16px rgba(157, 78, 221, 0.9), 0 0 32px rgba(123, 44, 191, 0.5)';
                                                                    const arrow = e.currentTarget.querySelector('.arrow');
                                                                    if (arrow) arrow.style.transform = 'translateX(5px)';
                                                                }}
                                                                onMouseLeave={e => {
                                                                    e.currentTarget.style.boxShadow = '0 0 12px rgba(157, 78, 221, 0.6)';
                                                                    const arrow = e.currentTarget.querySelector('.arrow');
                                                                    if (arrow) arrow.style.transform = 'translateX(0)';
                                                                }}
                                                            >
                                                                View More
                                                                <span className="arrow" style={{ transition: 'transform 0.3s ease', marginLeft: '10px' }}>➡</span>
                                                            </a>
                                                        </div>
                                                    );
                                                }

                                                // Property Card
                                                return (
                                                    <div
                                                        key={property.id}
                                                        style={{
                                                            scrollSnapAlign: 'start',
                                                            minWidth: isMobile && category.properties.length <= 3
                                                                ? 'calc(50% - 8px)'
                                                                : isMobile
                                                                    ? undefined
                                                                    : '220px',
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <Card
                                                            onClick={() => {
                                                                const titleSlug = property?.title
                                                                    ? property.title.trim().replace(/\s+/g, "-")
                                                                    : "property";
                                                                navigate(`/residential/${titleSlug}`);
                                                            }}
                                                            style={{
                                                                ...cardStyle,
                                                                cursor: "pointer",
                                                                border: "1px solid rgba(255, 255, 255, 0.15)",
                                                                transition: "all 0.2s ease",
                                                                height: property?.festive_offer === "yes" ? (isMobile ? "370px" : "360px") : "auto",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                overflow: "hidden",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            {/* 🔥 Scrolling Info */}
                                                            {/* {(property.festive_offer === "yes" ||
                                                                property.available_units ||
                                                                property.offer_units) && (
                                                                    <div
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "10px",
                                                                            left: "10px",
                                                                            right: "10px",
                                                                            overflow: "hidden",
                                                                            whiteSpace: "nowrap",
                                                                            borderRadius: "6px",
                                                                            background: "rgba(0,0,0,0.55)",
                                                                            zIndex: 20,
                                                                            padding: "2px 4px"
                                                                        }}
                                                                    >
                                                                        <div className="scroll-strip">
                                                                            ✨ Offer Deal Live |
                                                                            {property.available_units ? `${property.available_units} ${property.property_type} Ready | ` : ""}
                                                                            {property.offer_units ? `🎁 ${property.offer_units} Units with Special Discounts` : ""}
                                                                        </div>

                                                                    </div>
                                                                )} */}

                                                            {/* Image */}
                                                            {property.images?.length > 0 ? (
                                                                <MiniPropertySlider
                                                                    property={property}
                                                                    height={isMobile ? "130px" : "130px"}
                                                                    borderRadius="10px"
                                                                />
                                                            ) : (
                                                                <div
                                                                    className="d-flex align-items-center justify-content-center bg-secondary"
                                                                    style={{
                                                                        height: isMobile ? "130px" : "130px",
                                                                        borderTopLeftRadius: "10px",
                                                                        borderTopRightRadius: "10px",
                                                                    }}
                                                                >
                                                                    <span className="text-white" style={{ fontSize: "0.7rem" }}>
                                                                        No Image
                                                                    </span>
                                                                </div>
                                                            )}

                                                            {/* Card Body */}
                                                            <CardBody
                                                                className="p-2"
                                                                style={{
                                                                    flex: 1,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    justifyContent: "space-between",
                                                                    overflow: "hidden",
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        overflow: "hidden",
                                                                        flex: 1,
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        justifyContent: "space-between",
                                                                    }}
                                                                >
                                                                    <CardTitle
                                                                        tag="h6"
                                                                        className="mb-1 text-white"
                                                                        style={{
                                                                            fontSize: isMobile ? "0.7rem" : "0.8rem",
                                                                            fontWeight: "500",
                                                                            display: "-webkit-box",
                                                                            WebkitLineClamp: 1,
                                                                            WebkitBoxOrient: "vertical",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            minHeight: "1.2em",
                                                                        }}
                                                                    >
                                                                        {property.title && property.title.trim().length > 0
                                                                            ? `${property.title.trim().slice(0, 27)}${property.title.trim().length > 27 ? "..." : ""
                                                                            }`
                                                                            : (
                                                                                <span style={{ color: "#777777" }}>No Title</span>
                                                                            )}
                                                                    </CardTitle>

                                                                    <div className="mb-1">
                                                                        <small
                                                                            className="text-white-50"
                                                                            style={{
                                                                                fontSize: "0.65rem",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis",
                                                                                display: "block",
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-map-marker-alt me-1"></i>
                                                                            {property.location || "No Location"}
                                                                        </small>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                                        <span
                                                                            className="fw-bold text-white"
                                                                            style={{ fontSize: isMobile ? "0.7rem" : "0.75rem" }}
                                                                        >
                                                                            {property.price ? `₹${property.price}` : "No Price"}
                                                                        </span>
                                                                        <span className="text-white-50" style={{ fontSize: "0.7rem" }}>
                                                                            <i className="fas fa-bed me-1"></i>
                                                                            {property.property_details?.[0]?.bedrooms > 0
                                                                                ? `${property.property_details[0].bedrooms}`
                                                                                : "N/A"}
                                                                            BHK
                                                                        </span>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="text-white-50" style={{ fontSize: "0.65rem" }}>
                                                                            <i className="fas fa-ruler-combined me-1"></i>
                                                                            {property.area_sqft ? `${property.area_sqft} sqft` : "No Area"}
                                                                        </span>
                                                                        <span
                                                                            className="badge"
                                                                            style={{
                                                                                background: "rgba(255, 255, 255, 0.15)",
                                                                                color: "#ffffff",
                                                                                fontSize: "0.6rem",
                                                                                fontWeight: "normal",
                                                                                padding: "0.25rem 0.4rem",
                                                                            }}
                                                                        >
                                                                            {property.status || "No Status"}
                                                                        </span>
                                                                    </div>

                                                                    {/* AI Property Expert Box */}
                                                                    <div
                                                                        onClick={async (e) => {
                                                                            e.stopPropagation();
                                                                            setAiSelectedProperty(property);
                                                                            setAiModalOpen(true);
                                                                            try {
                                                                                const res = await getPropertyByTitle(property.title);
                                                                                const full = res?.data?.property;
                                                                                if (full) {
                                                                                    const normalizedImages = (full.images || []).map(img => {
                                                                                        if (typeof img === 'string') return img;
                                                                                        if (img?.url) return img.url.startsWith('/') ? img.url : '/' + img.url;
                                                                                        return null;
                                                                                    }).filter(Boolean);
                                                                                    setAiSelectedProperty({
                                                                                        ...property,
                                                                                        ...full,
                                                                                        images: normalizedImages.length > 0 ? normalizedImages : property.images,
                                                                                        videos: full.videos || [],
                                                                                    });
                                                                                }
                                                                            } catch (err) {
                                                                                console.warn('Failed to fetch full property for AI modal:', err);
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            background: 'rgba(74,222,128,0.1)',
                                                                            border: '1px solid rgba(74,222,128,0.4)',
                                                                            borderRadius: '7px',
                                                                            padding: '7px 9px',
                                                                            marginTop: '7px',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                <span style={{ fontSize: '11px' }}>✨</span>
                                                                                <span style={{ color: '#4ade80', fontSize: '0.68rem', fontWeight: 700 }}>AI Property Expert</span>
                                                                            </div>
                                                                            <span style={{
                                                                                background: '#00C853',
                                                                                color: '#fff', fontSize: '0.55rem', fontWeight: 800,
                                                                                padding: '2px 6px', borderRadius: '3px', letterSpacing: '0.3px',
                                                                            }}>SMART PICK</span>
                                                                        </div>
                                                                        <div style={{ color: '#d4fce8', fontSize: '0.65rem', lineHeight: 1.4, marginBottom: '3px' }}>
                                                                            ✓ {generateAIInsights(property)[0] || 'AI analysis available'}
                                                                        </div>
                                                                        {generateAIInsights(property)[1] && (
                                                                            <div style={{ color: '#d4fce8', fontSize: '0.65rem', lineHeight: 1.4, marginBottom: '5px' }}>
                                                                                ✓ {generateAIInsights(property)[1]}
                                                                            </div>
                                                                        )}
                                                                        <div style={{ color: '#4ade80', fontSize: '0.62rem', fontWeight: 600 }}>
                                                                            Read full report →
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </CardBody>
                                                            <CardFooter className="border-0 bg-transparent p-1" />
                                                        </Card>

                                                        {/* 🔥 Global CSS */}
                                                        <style>
                                                            {`
                                                    .scroll-strip {
                                                        display: inline-block;
                                                        animation: scroll-left 15s linear infinite;
                                                        white-space: nowrap;
                                                        font-weight: 600;
                                                        font-size: 0.9rem;
                                                        letter-spacing: 0.6px;
                                                        color: #fff;
                                                        text-shadow:
                                                            0 0 4px black,
                                                            0 0 8px black,
                                                            0 0 12px rgba(255,255,255,0.8);
                                                        padding: 6px 12px;
                                                        border-radius: 6px;
                                                    }
                                                    @keyframes scroll-left {
                                                      0% { transform: translateX(0); }
                                                      100% { transform: translateX(-100%); }
                                                    }
                                                    .properties-container::-webkit-scrollbar {
                                                        height: 4px;
                                                    }
                                                    .properties-container::-webkit-scrollbar-track {
                                                        background: rgba(255, 255, 255, 0.05);
                                                        border-radius: 10px;
                                                    }
                                                    .properties-container::-webkit-scrollbar-thumb {
                                                        background: linear-gradient(90deg, #7B2FBE, #9D4EDD);
                                                        border-radius: 10px;
                                                    }
                                                    .properties-container::-webkit-scrollbar-thumb:hover {
                                                        background: linear-gradient(90deg, #9D4EDD, #c77dff);
                                                    }
                                                    .ai-modal-scroll::-webkit-scrollbar { display: none; }
                                                    .ai-modal-scroll-x::-webkit-scrollbar { height: 4px; }
                                                    .ai-modal-scroll-x::-webkit-scrollbar-thumb {
                                                        background: linear-gradient(90deg, #7B2FBE, #9D4EDD);
                                                        border-radius: 10px;
                                                    }
                                                      `}
                                                        </style>

                                                    </div>
                                                );
                                            })}
                                        </div>

                                            {/* Right Arrow — only when enough cards to scroll */}
                                            {category.properties.length > (isMobile ? 2 : 4) && (
                                            <button
                                                onClick={() => scrollContainer(category.category_id, 1)}
                                                style={{
                                                    position: 'absolute', right: '-14px', top: '45%',
                                                    transform: 'translateY(-50%)', zIndex: 20,
                                                    background: 'linear-gradient(135deg, #7B2FBE, #9D4EDD)',
                                                    border: 'none', borderRadius: '50%',
                                                    width: '34px', height: '34px',
                                                    color: '#fff', cursor: 'pointer',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    fontSize: '18px', fontWeight: 'bold',
                                                    boxShadow: '0 4px 14px rgba(123,47,190,0.6)',
                                                    lineHeight: 1,
                                                }}
                                            >›</button>
                                            )}
                                        </div>
                                    </div>
                                ))}

                            <Row>
                                <Col xl={12} sm={8} >
                                    {Array.isArray(properties) && properties.length > 0 ? (
                                        properties.map((property, index) => (
                                            <Card key={property.id || index} style={cardStyle}
                                                onClick={() =>
                                                    navigate(
                                                        `/residential/${property.title.replace(/\s+/g, "-")}`
                                                    )
                                                }
                                            >
                                                <CardBody>
                                                    <div className="row g-3 align-items-center">
                                                        <div className="col-md-4">
                                                            <div className="product-img position-relative">
                                                                {property.images?.length > 0 ? (
                                                                    <PropertyImageSlider
                                                                        property={property}
                                                                        height="180px" // pass height as prop if you like
                                                                        borderRadius="10px"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={productImages[0]} // your default image
                                                                        alt="Default property"
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "180px",
                                                                            objectFit: "cover",
                                                                            borderRadius: "10px",
                                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                                            border: "1px solid #FFD700",
                                                                        }}
                                                                    />
                                                                )}


                                                                <div
                                                                    className="position-absolute w-100 text-center"
                                                                    style={{
                                                                        bottom: "-14px",
                                                                        left: "0",
                                                                        color: "#E8E8FF",
                                                                        fontSize: "0.85rem",
                                                                        fontWeight: "500",
                                                                        padding: "6px 0",
                                                                        background: "rgba(28, 20, 44, 0.9)",
                                                                        borderRadius: "0 0 10px 10px",
                                                                    }}
                                                                >
                                                                    {property.title}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-8">
                                                            <h6 className="mb-1 text-truncate">
                                                                <Link
                                                                    to={"/residential/4bhk-villa-Krishna-Bhuvi-bhayli-Vadodara"}
                                                                    className="fw-bold"
                                                                    style={{
                                                                        color: "#E8E8FF",
                                                                        fontSize: "1.05rem",
                                                                    }}
                                                                >
                                                                    {property.title}
                                                                </Link>
                                                            </h6>

                                                            {/* Location */}
                                                            <p className="mb-1" style={{ color: "#A3C4FF", fontSize: "0.75rem" }}>
                                                                <i className="bi bi-geo-alt-fill" style={{ color: "#00C6D7", fontSize: "0.85rem" }}></i>
                                                                {property.location}, {property.city}
                                                            </p>

                                                            {/* Status */}
                                                            <h6 className="fw-bold mb-1" style={{ color: "#FFD700", fontSize: "0.8rem" }}>
                                                                {property.status}
                                                            </h6>

                                                            {property.posted_by && (
                                                                <h6 className="fw-bold mb-1" style={{ color: "#C0C0C0", fontSize: "0.75rem" }}>
                                                                    Posted By {property.posted_by}
                                                                </h6>
                                                            )}

                                                            <h6 className="fw-bold mb-1" style={{ color: "white", fontSize: "0.75rem" }}>
                                                                {property.features}
                                                            </h6>

                                                            {/* Property Details */}
                                                            {property?.property_details?.some(
                                                                detail => detail.bedrooms || detail.carpetArea || detail.price
                                                            ) && (
                                                                    <div className="d-flex gap-1 mb-2">
                                                                        {property.property_details.map((detail, index) => {
                                                                            // Skip empty details
                                                                            if (!detail.bedrooms && !detail.carpetArea && !detail.price) return null;

                                                                            return (
                                                                                <div
                                                                                    key={index}
                                                                                    className="p-1 rounded shadow"
                                                                                    style={{
                                                                                        background:
                                                                                            index % 2 === 0
                                                                                                ? "linear-gradient(135deg, #6A0572, #9C1DE7)"
                                                                                                : "linear-gradient(135deg, #085078, #67B26F)",
                                                                                        color: "#FFFFFF",
                                                                                        flex: 1,
                                                                                    }}
                                                                                >
                                                                                    {detail.bedrooms && (
                                                                                        <div style={{ fontSize: "0.75rem", fontWeight: "600" }}>
                                                                                            {detail.bedrooms} BHK
                                                                                        </div>
                                                                                    )}

                                                                                    {detail.carpetArea && (
                                                                                        <div style={{ fontSize: "0.7rem" }}>
                                                                                            Carpet: {detail.carpetArea} sq.ft.
                                                                                        </div>
                                                                                    )}

                                                                                    {detail.price && (
                                                                                        <div style={{ fontSize: "0.7rem" }}>
                                                                                            ₹{detail.price}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}


                                                            {/* Description */}
                                                            <p
                                                                className="mb-1"
                                                                style={{
                                                                    color: "#A3C4FF",
                                                                    fontSize: "0.75rem",
                                                                    lineHeight: "1rem",
                                                                    maxHeight: "2rem",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {property.description}
                                                            </p>

                                                            {/* Date */}
                                                            {property.created_at && (
                                                                <div className="d-flex justify-content-between align-items-center mt-1">
                                                                    <h6
                                                                        className="fw-bold mb-0"
                                                                        style={{ color: "#C0C0C0", fontSize: "0.7rem" }}
                                                                    >
                                                                        Posted on : {(() => {
                                                                            const date = new Date(property.created_at);
                                                                            const day = String(date.getDate()).padStart(2, "0");
                                                                            const month = String(date.getMonth() + 1).padStart(2, "0");
                                                                            const year = date.getFullYear();
                                                                            return `${day}-${month}-${year}`;
                                                                        })()}
                                                                    </h6>

                                                                    <Link to="/Emi-Calculator" onClick={(e) => e.stopPropagation()}>
                                                                        <button
                                                                            className="btn"
                                                                            style={{
                                                                                background: "linear-gradient(135deg, #FFD700, #FFA500)",
                                                                                color: "#1C142C",
                                                                                fontWeight: "600",
                                                                                border: "none",
                                                                                borderRadius: "4px",
                                                                                padding: "4px 10px",
                                                                                fontSize: "0.75rem",
                                                                                boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                                                                                transition: "transform 0.2s ease-in-out",
                                                                            }}
                                                                            onMouseEnter={(e) =>
                                                                                (e.currentTarget.style.transform = "scale(1.05)")
                                                                            }
                                                                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                                                        >
                                                                            EMI Calculator
                                                                        </button>
                                                                    </Link>
                                                                </div>
                                                            )}


                                                            {/* Ratings */}
                                                            <div className="d-flex align-items-center mb-1">
                                                                <StarRatings
                                                                    starRatedColor="#FFD700"
                                                                    starEmptyColor="#53576D"
                                                                    numberOfStars={0}
                                                                    name="rating"
                                                                    starDimension="16px"
                                                                    starSpacing="1px"
                                                                />
                                                                <span className="ms-2" style={{ color: "#A3C4FF", fontSize: "0.7rem" }}>
                                                                    {/* (X reviews) */}
                                                                </span>
                                                            </div>


                                                        </div>
                                                    </div>

                                                </CardBody>

                                            </Card>
                                        ))
                                    ) : (
                                        <div className="text-center py-4">
                                            {/* <p className="text-white">No properties found matching your search</p> */}
                                            <button
                                                onClick={clearSearch}
                                                className="btn btn-sm btn-outline-light"
                                                style={{
                                                    fontSize: '0.8rem',
                                                    padding: '0.25rem 0.5rem',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px',
                                                    marginTop: '0.5rem'
                                                }}
                                            >
                                                <FiArrowLeft size={14} />
                                                Back to Home Page
                                            </button>
                                        </div>
                                    )}
                                    <div
                                        style={{
                                            position: "fixed",
                                            bottom: "20px",
                                            right: "20px",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            zIndex: 1000,
                                        }}
                                    >
                                        {/* Icons Container */}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginBottom: "12px",
                                                gap: "10px", // Reduced gap for a more compact design
                                            }}
                                        >
                                            {/* WhatsApp Icon */}
                                            <a
                                                href={generateWhatsAppLink()}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "white",
                                                    fontSize: "1.2rem", // Reduced font size
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: "40px", // Reduced icon size
                                                    height: "40px",
                                                    background: "linear-gradient(135deg, #1FAF51, #25D366)", // Slightly adjusted green gradient
                                                    borderRadius: "50%",
                                                    boxShadow: "0px 3px 10px rgba(31, 175, 81, 0.6)",
                                                    transition: "all 0.3s ease",
                                                }}
                                                title="Chat on WhatsApp"
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = "scale(1.1)";
                                                    e.target.style.boxShadow = "0px 5px 15px rgba(31, 175, 81, 0.8)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = "scale(1)";
                                                    e.target.style.boxShadow = "0px 3px 10px rgba(31, 175, 81, 0.6)";
                                                }}
                                            >
                                                <FaWhatsapp />
                                            </a>

                                            {/* Call Icon */}
                                            <a
                                                href="tel:+919586363303"
                                                style={{
                                                    color: "white",
                                                    fontSize: "1.2rem", // Reduced font size
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: "40px", // Reduced icon size
                                                    height: "40px",
                                                    background: "linear-gradient(135deg, #1E90FF, #34B7F1)", // Slightly adjusted blue gradient
                                                    borderRadius: "50%",
                                                    boxShadow: "0px 3px 10px rgba(30, 144, 255, 0.6)",
                                                    transition: "all 0.3s ease",
                                                }}
                                                title="Call Us"
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = "scale(1.1)";
                                                    e.target.style.boxShadow = "0px 5px 15px rgba(30, 144, 255, 0.8)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = "scale(1)";
                                                    e.target.style.boxShadow = "0px 3px 10px rgba(30, 144, 255, 0.6)";
                                                }}
                                            >
                                                <i className="fas fa-phone" />
                                            </a>
                                        </div>

                                        {/* Query Button */}
                                        <Link
                                            to="/dashboard"
                                            title="Any Questions or Queries?"
                                            style={{
                                                background: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient effect for the button
                                                border: "none",
                                                borderRadius: "9999px",
                                                padding: "10px 20px", // Adjusted padding
                                                fontSize: "14px", // Reduced font size
                                                color: "white",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                                                transition: "all 0.3s ease",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = "scale(1.1)";
                                                e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = "scale(1)";
                                                e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.3)";
                                            }}
                                        >
                                            Ask Ai &nbsp; <i className="fas fa-question" style={{ margin: 0 }}></i>
                                        </Link>
                                    </div>

                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div >

            {/* AI Property Expert Modal */}
            <AIExpertModal
                isOpen={aiModalOpen}
                property={aiSelectedProperty}
                onClose={() => { setAiModalOpen(false); setAiSelectedProperty(null); }}
            />
        </React.Fragment >
    );
};

export default withRouter(OfferProperty);
